import React from "react";
import { useSelector, useDispatch } from "react-redux";
import "./index.scss";
import { isEqual } from "date-fns";
import { getLiveboardGuid } from "../../../thoughtspot-sdk-app-embed/full-app-embed";
import DownloadLiveBoardPopup, {
  toggleDownloadLiveBoardPopup,
} from "../../../thoughtspot-sdk-app-embed/download-liveboard-pop-up";
import MdaeButton from "../../button";

const ROISummaryPageTitleComponent: React.FC<{ any }> = ({}) => {
  const dispatch = useDispatch();

  const isDownloadPopupOpen = useSelector(
    (state) => state["downloadPopupReducer"].isDownloadPopupOpen
  );
  const mdaePageTitle = useSelector(
    (state) => state["mdaeNavigationBarReducer"].mdaePageTitle,
    isEqual
  );
  const thoughtSpotSettings = useSelector(
    (state) => state["mdaeNavigationBarReducer"].thoughtSpotSettings,
    isEqual
  );
  const onDownloadROISummaryClick = () => {
    let currentLiveBoardId = "";
    let currentLiveBoardName = "";

    if (mdaePageTitle && mdaePageTitle.toLowerCase() === "internal audit roi") {
      currentLiveBoardId = getLiveboardGuid(
        "auditroi",
        thoughtSpotSettings.objectList
      );
      currentLiveBoardName = "auditroi";
    }
    if (mdaePageTitle && mdaePageTitle.toLowerCase() === "payer audit roi") {
      currentLiveBoardId = getLiveboardGuid(
        "payerauditroi",
        thoughtSpotSettings.objectList
      );
      currentLiveBoardName = "payerauditroi";
    }

    toggleDownloadLiveBoardPopup(
      isDownloadPopupOpen,
      dispatch,
      currentLiveBoardId,
      currentLiveBoardName
    );
  };

  const isRoiPage =
    mdaePageTitle &&
    (mdaePageTitle.toLowerCase() === "internal audit roi" ||
      mdaePageTitle.toLowerCase() === "payer audit roi");

  if (!isRoiPage) return null;

  return (
    <>
      <div className="content">{mdaePageTitle}</div>
      <div className="ai-summary-button-container">
        <MdaeButton
          id="custom-download-btn"
          role="secondary"
          text="Download ROI Summary"
          onClick={onDownloadROISummaryClick}
        />
      </div>
      <DownloadLiveBoardPopup />
    </>
  );
};

export default ROISummaryPageTitleComponent;
